import type React from 'react';
import { CostGroupsSection } from './CostGroupsSection';
import { CostGroupYearRatesSection } from './CostGroupYearRatesSection';
import { EmployeeCostGroupAssignmentsSection } from './EmployeeCostGroupAssignmentsSection';

export type CostGroupSection = 'cost-groups' | 'group-rates' | 'employee-assignments';

interface CostGroupSettingsProps {
  section: CostGroupSection;
}

export const CostGroupSettings: React.FC<CostGroupSettingsProps> = ({ section }) => {
  return (
    <>
      {section === 'cost-groups' && <CostGroupsSection />}
      {section === 'group-rates' && <CostGroupYearRatesSection />}
      {section === 'employee-assignments' && <EmployeeCostGroupAssignmentsSection />}
    </>
  );
};
